import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import BottomMenu from "./BottomMenu";
import {
  SalesforceObjectType,
  SalesforceImportStep,
  SalesforceSettingStep,
  DialogType,
} from "../../../../constants/ComponentTypes";
import { SALESFORCE_PREVIEW_LIMIT } from "../../../../constants/Constants";
import MappingTable from "./MappingTable";
import { importMappingToParams } from "../../../../utils/utils";

const styles = () => ({
  root: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    padding: "60px 0",
  },

  box: {
    maxWidth: "940px",
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginBottom: "90px",
  },

  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "26px",
  },

  desc: {
    fontSize: "14px",
    paddingBottom: "20px",
  },

  note: {
    color: "#5A5B62",
    fontSize: "12px",
    marginTop: "20px",
  },

  bottomMenu: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    zIndex: 2,
  },

  fields: {
    borderTop: "1px solid #E7E9EB",
    paddingTop: "30px",
  },

  row: {
    marginBottom: "30px",
  },

  fieldTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "12px",
  },

  fieldDesc: {
    fontSize: "14px",
  },
});

class SalesforceMapping extends React.Component {
  state = {
    showBottomMenu: false,
    nextBtnPressed: true,
  };

  componentWillMount() {
    this.setState({
      showBottomMenu: !this.isEmptySelection(this.props.mapping),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isLoadingPreview &&
      !nextProps.isLoadingPreview &&
      this.state.nextBtnPressed
    ) {
      if (nextProps.type === DialogType.EDIT) {
        nextProps.goToStep(SalesforceSettingStep.PREVIEW);
      }
      this.setState({
        nextBtnPressed: false,
      });
    }

    if (this.props.isConfiguring && !nextProps.isConfiguring) {
      if (nextProps.type === DialogType.EDIT) {
        nextProps.goToStep(SalesforceSettingStep.SETTING_COMPLETE);
      } else {
        nextProps.goToStep(SalesforceImportStep.SETTING_COMPLETE);
      }
    }
  }

  /*** handlers ***/
  handleUpdateMapping = (mapping) => {
    this.props.updateMapping(mapping);
    this.setState({
      showBottomMenu: !this.isEmptySelection(mapping),
    });
  };

  handlePrev = () => {
    const { type } = this.props;
    if (type === DialogType.EDIT) {
      if (this.props.step === SalesforceSettingStep.PREVIEW) {
        this.props.goToStep(SalesforceSettingStep.MAPPING);
      } else if (this.props.step === SalesforceSettingStep.MAPPING) {
        this.props.goBack();
      }
    } else {
      if (this.props.step === SalesforceImportStep.PREVIEW) {
        this.props.goToStep(SalesforceImportStep.MAPPING);
      } else if (this.props.step === SalesforceImportStep.MAPPING) {
        this.props.goToStep(SalesforceImportStep.SELECT_LISTVIEW);
      }
    }
  };

  handleNext = () => {
    const { type, mapping } = this.props;

    this.setState({
      nextBtnPressed: true,
    });

    let previewParams = {
      ...importMappingToParams(mapping, SALESFORCE_PREVIEW_LIMIT),
      listview_id: this.props.listview_id,
    };

    let importParams = {
      ...importMappingToParams(mapping),
      listview_id: this.props.listview_id,
      export_flag: 1, //TODO: default the export flag to always be 1 for now
    };

    if (type === DialogType.EDIT) {
      if (this.props.step === SalesforceSettingStep.MAPPING) {
        this.props.getSalesforcePreview(previewParams);
        this.props.goToStep(SalesforceSettingStep.PREVIEW);
      } else if (this.props.step === SalesforceSettingStep.PREVIEW) {
        this.props.postSalesforceConfig(importParams);
      }
    } else {
      if (this.props.step === SalesforceImportStep.MAPPING) {
        this.props.getSalesforcePreview(previewParams);
        this.props.goToStep(SalesforceImportStep.PREVIEW);
      } else if (this.props.step === SalesforceImportStep.PREVIEW) {
        this.props.postSalesforceConfig(importParams);
      }
    }
  };

  /*** helper functions ***/
  enableEdit = () => {
    const { type, step } = this.props;

    if (type === DialogType.EDIT) {
      return step === SalesforceSettingStep.MAPPING;
    } else {
      return step === SalesforceImportStep.MAPPING;
    }
  };

  isEmptySelection = (mapping) => {
    let mappingArray = mapping.toIndexedSeq();
    let isEmpty = true;
    mappingArray.forEach((map) => {
      if (typeof map !== "string") {
        isEmpty = isEmpty && (!map || map.count() === 0);
      }
    });

    return isEmpty;
  };

  /*** render functions ***/

  renderBottomMenu = () => {
    const { user } = this.props;
    let requiredFields = [];

    if (user && !user.corporate_number_validation_flag) {
      requiredFields = [
        { key: ["post_code"], text: "郵便番号は必須です" },
        { key: ["address"], text: "住所は必須です" },
        { key: ["company"], text: "会社名は必須です" },
        { key: ["name"], text: "名前は必須です" },
      ];
    } else {
      requiredFields = [
        { key: ["post_code"], text: "郵便番号は必須です" },
        { key: ["address"], text: "住所は必須です" },
        { key: ["company"], text: "会社名は必須です" },
        { key: ["name"], text: "名前は必須です" },
        { key: ["corporate_number"], text: "法人番号は必須です" },
      ];
    }

    return (
      <BottomMenu
        requiredFields={requiredFields}
        step={this.props.step}
        open={this.state.showBottomMenu}
        mapping={this.props.mapping}
        isLoadingPreview={this.props.isLoadingPreview}
        loadingPreviewFailed={this.props.loadingPreviewFailed}
        isConfiguring={this.props.isConfiguring}
        next={this.handleNext}
        prev={this.handlePrev}
      />
    );
  };

  render() {
    const { classes, step, preview, mapping, fields, sobject } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <Typography variant="subheading" className={classes.title}>
            {step === SalesforceImportStep.MAPPING
              ? "同期する項目をマッピングしてください"
              : "以下のマッピングで同期します。よろしいですか？"}
          </Typography>
          <Typography variant="body2" className={classes.desc}>
            {step === SalesforceImportStep.MAPPING
              ? "SalesforceからKeyman Letterへの同期を自動化するための項目マッピングを設定します。下記Keyman Letter項目に該当するSalesforce項目を追加(複数可※1)してください。この設定は「アカウント管理 > 連携」よりいつでも変更できます。"
              : "問題ない場合は「設定を保存」ボタンをクリックして設定を完了させてください。自社リストのインポート設定は、「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。"}
          </Typography>

          {(() => {
            if (step === SalesforceImportStep.PREVIEW) {
              return (
                <div className={classes.fields}>
                  <div className={classes.row}>
                    <Typography variant="title" className={classes.fieldTitle}>
                      Salesforceオブジェクト
                    </Typography>
                    <Typography variant="body2" className={classes.fieldDesc}>
                      {SalesforceObjectType[sobject.toUpperCase()].text}
                    </Typography>
                  </div>

                  <div className={classes.row}>
                    <Typography variant="title" className={classes.fieldTitle}>
                      リストビュー
                    </Typography>

                    <Typography variant="body2" className={classes.fieldDesc}>
                      {this.props.listview_id === null
                        ? "未選択（全てのレコードを同期する）"
                        : this.props.listviews.find(
                          (item) => item.id === this.props.listview_id
                        ).label}
                    </Typography>
                  </div>
                </div>
              );
            }
          })()}

          <div className={classes.row}>
            <Typography variant="title" className={classes.fieldTitle}>
              インポート設定・項目マッピング
            </Typography>
            <MappingTable
              sobject={sobject}
              step={step}
              mapping={mapping}
              enableEdit={this.enableEdit()}
              isLoadingMapping={this.props.isLoadingMapping}
              isLoadingPreview={this.props.isLoadingPreview}
              fields={fields}
              preview={preview}
              disabled={this.props.isJobCompletedLoading || this.props.isLoadingPreview}
              updateMapping={this.handleUpdateMapping}
            />
          </div>

          {step === SalesforceImportStep.MAPPING && (
            <Typography className={classes.note}>
              ※1 サービス間でデータ構造が異なる場合があるため、1つのKeyman
              Letter項目に対し、複数のSalesforce項目を結合してマッピングすることができます。たとえば、Keyman
              Letterでは住所が一つの項目にまとまっていますが、Salesforceでは複数の項目に分かれているかもしれません。
              取引先責任者と連携する場合、取引先責任者の郵便番号・住所がない場合、取引先の郵便番号・住所が適用されます。
            </Typography>
          )}
        </div>
        <div className={classes.bottomMenu}>{this.renderBottomMenu()}</div>
      </div>
    );
  }
}

SalesforceMapping.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.number,
  step: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  mapping: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  preview: PropTypes.array,
  isLoadingPreview: PropTypes.bool,
  isJobCompletedLoading: PropTypes.bool,
  goToStep: PropTypes.func.isRequired,
  updateMapping: PropTypes.func.isRequired,
  postSalesforceConfig: PropTypes.func.isRequired,
  getSalesforcePreview: PropTypes.func.isRequired,
  listview_id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  listviews: PropTypes.array,
  sobject: PropTypes.string,
  user: PropTypes.object,
  goBack: PropTypes.func.isRequired,
  loadingPreviewFailed: PropTypes.bool,
  isLoadingMapping: PropTypes.bool,
  isConfiguring: PropTypes.bool,
};

SalesforceMapping.defaultProps = {
  type: DialogType.CREATE,
  isLoadingPreview: false,
  isJobCompletedLoading: false,
};

export default withStyles(styles)(SalesforceMapping);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceAddressSetting/SalesforceMapping.jsx